import { tokens } from './tokens';
import { breakpoints } from './breakpoints';
import { BaseTheme } from './types';

export const baseTheme: BaseTheme = {
  tokens,
  breakpoints,
  name: 'base-theme',
};
